// extracted by mini-css-extract-plugin
export var banner = "_ov-0";
export var settingRow = "_ov-2";
export var titleIcon = "_ov-1";